// extracted by mini-css-extract-plugin
export default {"selectedTag":"SelectTag_selectedTag__wOmCC"};